import React from "react";
import { useLocation } from "react-router-dom";
import DefaultCard from "./cards/DefaultCard";
import DeliverBinCard from "./cards/DeliverBinCard";
import EmptyBinCard from "./cards/EmptyBinCard";
import PickupCard from "./cards/PickupCard";

const slug = (s) =>
  String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "");

// Map many spellings/codes → one canonical key used below
function toCanonicalKey(raw) {
  const s = slug(raw);
  if (["empty", "emptybin", "empty-bin", "bin-empty", "emp"].includes(s)) return "empty-bin";
  if (["pickup", "pick-up", "bin-pickup", "pickup-bin", "pk"].includes(s)) return "bin-pickup";
  if (["delivery", "bin-delivery", "deliver", "deliver-bin", "drop-bin", "dv", "rp"].includes(s)) return "bin-delivery";
  return s; // unknown → passthrough (will fall back to DefaultCard)
}

const registry = {
  "empty-bin": EmptyBinCard,
  "bin-pickup": PickupCard,
  "bin-delivery": DeliverBinCard,
};

function decideKey(job, search) {
  // 1) URL override (?card=pickup|empty|deliver)
  const qp = new URLSearchParams(search).get("card");
  if (qp) return toCanonicalKey(qp);

  // 2) Company job type *code* first (now words like "pick-up", "empty", "deliver", "RP")
  const codeKey = toCanonicalKey(job?.jobTypeCode || job?.jobTypeKey || "");
  if (registry[codeKey]) return codeKey;

  // RP is a special code that should behave like deliver
  if (slug(job?.jobTypeCode || "") === "rp") return "bin-delivery";

  // 3) Fall back to name
  const nameKey = toCanonicalKey(job?.jobTypeName || job?.jobType || "");
  if (registry[nameKey]) return nameKey;

  return "bin-delivery"; // last-resort default
}

export default function JobTypeCardRouter({ job, company }) {
  const { search } = useLocation();
  const key = decideKey(job, search);
  const Comp = registry[key] || DefaultCard;
  return <Comp job={job} company={company} />;
}
